import { render, staticRenderFns } from "./message-input-editor.vue?vue&type=template&id=4edba760&scoped=true"
import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-input-editor.vue?vue&type=style&index=0&id=4edba760&prod&scoped=true&lang=scss"
import style1 from "./message-input-editor.vue?vue&type=style&index=1&id=4edba760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edba760",
  null
  
)

export default component.exports